import React, { useState } from 'react';
import { Check } from 'lucide-react';

const PrivacyPolicyForm = ({ onAgree }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleAgree = () => {
    if (isChecked) {
      onAgree();
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-lg font-bold text-center">개인정보 수집 및 이용 동의</h2>

      <div className="space-y-4 text-sm">
        <h3 className="text-center font-semibold">개인정보 수집 및 이용에 대한 안내</h3>
        <p>학원 입학 및 교육서비스 제공·안내 등을 위하여, 본 학원은 학생의 개인정보를 수집·이용하거나 제3자에게 제공하고자 합니다. 단, 만 14세 미만 학생의 경우에는 법정대리인(학부모 등)의 동의를, 만 14세 이상 학생의 경우에는 학생 본인과 학부모(법정대리인)의 공동 동의를 받아 진행함을 원칙으로 합니다.
        (본 동의서는 [개인정보 보호법] 제15조 제1항 제1호, 제17조 제1항 제1호, 제21조, 제22조 제3항 및 제5항, 제24조 제1항 제1호에 근거합니다.)</p>

        <h4 className="font-semibold">1. 개인정보 수집·이용 목적</h4>
        <p>본 학원은 다음의 목적으로 귀하의 개인정보를 수집·이용 또는 제3자에게 제공할 수 있습니다.</p>
        <ul className="list-disc pl-5">
          <li>교육서비스 제공 및 안내</li>
          <li>학원 홍보·마케팅 및 광고 활용</li>
          <li>시설 안전 관리</li>
        </ul>

        <h4 className="font-semibold">2. 수집·이용할 개인정보 항목</h4>
        <ul className="list-disc pl-5">
          <li>개인식별정보: 학생 성명, 생년월일, 가상계좌번호, 학교, 학년, 집전화번호, 휴대전화번호, 집주소, 이메일주소, 성적표, FAX 번호, 법정대리인(학부모) 정보(만 14세 미만 학생의 경우)</li>
          <li>교육 관련 정보: 교육서비스 이용기록, 학생의 학습 평가 정보(문제 정오답 여부, 시험 및 평가 결과, 학습 성과 등), 수강료 납부기록, 수강료 반환정보(학부모 성명, 은행계좌번호)</li>
          <li>세금 및 증빙 관련 정보: 국세청 현금영수증 발급요청 정보(학부모 휴대전화번호 또는 현금영수증 카드번호, 사업자등록번호)</li>
          <li>기타: CCTV 촬영 정보</li>
        </ul>

        <h4 className="font-semibold">3. 개인정보의 보유·이용 기간 및 파기</h4>
        <p>수집된 개인정보는 해당일로부터 최대 3년간 보관되며, 수집·이용 및 제공 목적이 달성된 경우 [개인정보 보호법] 제21조에 따라 지체 없이 파기됩니다.
        다만, 학원 수업 중단 후에는 내부 방침 및 상기 목적(사고 조사, 분쟁 해결, 민원 처리, 법령상 의무 이행 등)과 관련하여 필요한 범위 내에서 보유·이용될 수 있습니다.</p>

        <h4 className="font-semibold">4. 동의를 거부할 권리 및 동의 거부 시 불이익</h4>
        <p>귀하는 개인정보 제공에 대한 동의를 거부할 권리가 있으며, 동의 후에도 언제든지 철회할 수 있습니다. 다만, 동의하지 않으실 경우 교육서비스 제공·안내 등 관련 혜택이나 편의를 제공받지 못할 수 있습니다.</p>

        <h4 className="font-semibold">5. 동의 대상 및 추가 동의 사항</h4>
        <ul className="list-disc pl-5">
          <li><strong>(만 14세 이상 학생의 경우)</strong> 본인은 학생으로서, 본 학원에 의해 내 개인정보가 수집·이용·제공되는 것에 대해, 교육 관련 정보(교육서비스 이용기록, 학습 평가 정보, 수강료 납부기록 등)가 학부모(법정대리인)에게도 제공될 수 있음을 인지하고, 이에 대해 학부모(법정대리인)와 공동으로 동의함을 확인합니다.</li>
          <li><strong>(만 14세 미만 학생의 경우)</strong> 만 14세 미만 학생은 개인정보 처리에 관한 법적 동의 능력이 없으므로, 해당 학생의 개인정보 수집·이용·제공은 법정대리인(학부모)의 동의를 통해 진행됩니다. 이에 법정대리인(학부모)은 만 14세 미만 학생의 개인정보, 교육 관련 정보가 본 학원에 의해 수집·이용·제공되는 것에 대해 동의함을 확인합니다.</li>
        </ul>

        <p>위와 같이 [개인정보 보호법] 제15조, 제17조, 제21조, 제22조 및 제24조에 근거하여, 본 학원이 학생의 개인정보를 수집·이용·제공하는 것에 동의합니다.</p>
      </div>

      <div className="flex items-start space-x-2">
        <div
          onClick={() => setIsChecked(!isChecked)}
          className={`flex-shrink-0 w-5 h-5 border rounded flex items-center justify-center cursor-pointer ${
            isChecked ? 'bg-[#4ABC85] border-[#4ABC85]' : 'border-gray-300'
          }`}
          style={{ minWidth: '20px', minHeight: '20px' }}
        >
          {isChecked && <Check size={16} color="white" />}
        </div>
        <label className="text-sm text-gray-600 cursor-pointer" onClick={() => setIsChecked(!isChecked)}>
          [개인정보 보호법] 제15조 및 제17조에 따라 위 내용으로 개인정보를 수집·이용 및 제공하는데 동의합니다.
        </label>
      </div>

      <button
        onClick={handleAgree}
        disabled={!isChecked}
        className={`w-full h-[60px] bg-[#4ABC85] text-white rounded-2xl font-bold text-lg ${
          !isChecked ? 'opacity-40 cursor-not-allowed' : ''
        }`}
      >
        가입하기
      </button>
    </div>
  );
};

export default PrivacyPolicyForm;